import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconBase from '@/components/IconBase.vue'
import IconForwardBack from '@/components/icons/arrowForward.vue'
import Globals from '@/assets/scripts/global-functions.js'
import BackButton from '@/components/BackButton.vue'
import NextButton from '@/components/forms/ButtonNext.vue'

export default {
    $_veeValidate: {
      validator: 'new'
    },
    name: "CoordinationUnit",
    components: {
        IconArrowBack,
        IconBase,
        IconForwardBack,
        BackButton,
        NextButton
    },
    data: () => ({
        coordination_unit: "",
        dictionary: {
            custom: {
                coordination_unit: {
                    required: () => 'Coordination unit is required to proceed',
                    max: 'Cannot exceed more than 255 characters'
                }
            }
        }
    }),
    methods: {
        ValidateCoordinationUnit() {
            /*
            Function:
                ► Checks the field mailing address if valid 
                ► Goes to next step when valid
            */
            this.$validator.validateAll().then((result) => {
                if(result) {
                    this.$parent.EducatorInsuranceProcess.coordination_unit = this.coordination_unit;
                    this.$parent.EducatorNextStep(9,"MailingAddress"); 
                } else {
                    console.error("There seems to be an error in your entries");
                } 
            });
            
        },
        ValidateSessionData() {
            /*
            Function:
                ► Runs onload
                ► Checkes data from the object and puts it on the field 
            */
            if(this.$parent.EducatorInsuranceProcess.coordination_unit != null) {
                this.coordination_unit = this.$parent.EducatorInsuranceProcess.coordination_unit;
                this.$validator.validateAll(); /* this was added to add success state on fields and buttons */
            }
        }
    },
    computed: {
        AllFieldsValid: function() {
            /*
            Function:
                ► Used to monitor the data from the fields, if valid, it will highlight the next button indicating that's ok to proceed to next step
            */
            let _isvalid = false;
            if(this.fields.coordination_unit) {
                if(this.fields.coordination_unit.valid) { _isvalid = true; }
            }

            return _isvalid;
        }
    },
    mounted() {
        this.$validator.localize('en', this.dictionary) 
        this.$parent.CheckWindowPathName();
        this.ValidateSessionData();
        this.$parent.CurrentProcess = "EducatorInsuranceProcess";
    }
}